module.exports = __webpack_public_path__ + "img/product_103.d90c8de.webp";